import { forward, toPoint } from 'mgrs';

/** 10-digit MGRS (1 meter), shown as `4QFJ 03584 71053`. */

export function formatMgrs(lat: number, lng: number): string {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return '';
  const raw = forward([lng, lat], 5).toUpperCase();
  const match = raw.match(/^(\d{1,2}[A-Z]{3})(\d+)$/);
  if (!match) return raw;
  const digits = match[2];
  const half = digits.length / 2;
  return `${match[1]} ${digits.slice(0, half)} ${digits.slice(half)}`;
}

export function parseMgrs(text: string): { lat: number; lng: number } | null {
  const compact = text.trim().toUpperCase().replace(/\s+/g, '');
  if (!compact) return null;
  try {
    const [lng, lat] = toPoint(compact);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    if (lat < -80 || lat > 84 || lng < -180 || lng > 180) return null;
    return { lat, lng };
  } catch {
    return null;
  }
}
